import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Form from "./Form";
import { articlesAPI } from "../services/api";

const NotFound = () => {
  const navigate = useNavigate();
  const [hasArticles, setHasArticles] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkArticles = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const response = await articlesAPI.getMyArticles();
          setHasArticles(response.data.articles.length > 0);
        } catch {
          setHasArticles(false);
        }
      }
      setLoading(false);
    };
    checkArticles();
  }, []);

  useEffect(() => {
    if (loading) return;
    
    const timer = setTimeout(() => {
      navigate(hasArticles ? "/myspace" : "/");
    }, 8000);

    return () => clearTimeout(timer);
  }, [navigate, hasArticles, loading]);

  return (
    <Form
      title="404"
      showCancel={false}
      showSubmit={false}
      footerLinks={
        <div style={{ marginTop: "20px" }}>
          <Link to={hasArticles ? "/myspace" : "/"}>Go {hasArticles ? "to MySpace" : "Home"}</Link>
        </div>
      }
    >
      <p>Page not found</p>
      <p>Redirecting to {hasArticles ? "MySpace" : "home page"} ...</p>
    </Form>
  );
};

export default NotFound;
